exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#content #content__header[data-v-34cf438e] {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.accordion[data-v-34cf438e] {\n  margin: 3rem 0;\n}\n.card + .card[data-v-34cf438e] {\n  margin-top: 2rem;\n}", ""]);

// exports
